import { Button, notification, Space } from 'antd'
import truncate from 'lodash/truncate'

import { toggleReportsAppDrawer } from 'actions/ui/app'
import storeRegistry from 'utilities/storeRegistry'

const top = 50
const duration = 5

export function showAsyncExportToast(
    reportName: string,
    description?: string
): void {
    notification.config({
        top,
        duration,
    })
    const btn = (
        <Space>
            <Button
                type="link"
                size="small"
                onClick={() => {
                    notification.destroy()
                    storeRegistry.dispatch(toggleReportsAppDrawer(true))
                }}
            >
                View Reports
            </Button>
        </Space>
    )
    notification.success({
        message: truncate(reportName),
        description: description ?? 'Your report is being generated.',
        btn,
    })
}
